module.exports = __webpack_public_path__ + "static/media/locked_request.2ffb34ec.mp3";